import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  fulfilledThunkState,
  initialThunkState,
  pendingThunkState,
  rejectedThunkState,
  THUNK_STATUS,
} from "@duosoftbg/nacid-components";
import { keycloakInitObject as keycloak } from "@duosoftbg/nacid-frontoffice-components";
import { getLoggedUserDetails } from "../../../../axios/api/services";

const initialState = {
  userDetails: {},
};

export const fetchLoggedUserDetails = createAsyncThunk(
  "loggedUserDetails/fetchStatus",
  async () => {
    const response = await getLoggedUserDetails()();
    return response;
  },
  {
    condition: (args, { getState, extra }) => {
      const userNotMatches =
        keycloak.authenticated &&
        keycloak.idTokenParsed.preferred_username !== getState()["AppData"]["loggedUser"].data.userDetails.username;
      return (
        keycloak.authenticated &&
        (getState()["AppData"]["loggedUser"].status !== THUNK_STATUS.FULFILLED || userNotMatches)
      );
    },
  },
);

const loggedUserSlice = createSlice({
  name: "loggedUserSlice",
  initialState: initialThunkState(initialState),
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchLoggedUserDetails.pending, (state, action) => {
      return pendingThunkState(initialState);
    });
    builder.addCase(fetchLoggedUserDetails.fulfilled, (state, action) => {
      const data = action.payload;
      return fulfilledThunkState({ userDetails: data });
    });
    builder.addCase(fetchLoggedUserDetails.rejected, (state, action) => {
      return rejectedThunkState(initialState);
    });
  },
});

export default loggedUserSlice.reducer;
